// extracted by mini-css-extract-plugin
export var columnList = "_gc-0";